export { initializeCorePageReady } from '@/features/observability/page/core-ready';
export { recordRumNavigation } from '@/features/observability/page/navigation';
